import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import axios from "axios";
import SignableDocument from "./components/SignableDocument";
import "./SignatureRecipientPage.scss";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import { FiArrowUp } from "react-icons/fi";
import { BASE_URL } from "config/config";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
export default function SignDocument() {
  const { token } = useParams();
  const [documentUrl, setDocumentUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recipientName, setRecipientName] = useState("");
  const [position, setPosition] = useState(null);
  const { t } = useTranslation();
  const [signatureType, setSignatureType] = useState("draw"); // draw | text | upload
  const [signatureText, setSignatureText] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [showRefusalModal, setShowRefusalModal] = useState(false);
  const [refusalReason, setRefusalReason] = useState("");
  console.log("showRefusalModal", showRefusalModal);
  const sigCanvas = useRef(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(`${BASE_URL}signatures/token/${token}`);
        setDocumentUrl(res?.data?.data?.documentId);
        setRecipientName(res?.data?.data?.recipientName);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    async function fetchDataPosition() {
      try {
        const res = await axios.get(`${BASE_URL}signatures/positions/${token}`);
        setPosition(res?.data?.data?.positions);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    fetchDataPosition();
    fetchData();
  }, [token]);

  function getImageURL(id) {
    return `${BASE_URL}documentsFile/${id}/file/singature`;
  }

  const clearSignature = () => sigCanvas.current.clear();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setUploadedImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const submitSignature = async () => {
    let signatureData = null;

    if (signatureType === "draw") {
      if (sigCanvas.current.isEmpty()) {
        alert(t("signature.desiner"));
        return;
      }
      signatureData = sigCanvas.current.toDataURL("image/png");
    } else if (signatureType === "text") {
      if (!signatureText.trim()) {
        alert(t("signature.entreText"));
        return;
      }
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = 400;
      canvas.height = 100;
      ctx.font = "italic 30px 'Pacifico', cursive";
      ctx.fillText(signatureText, 20, 50);
      signatureData = canvas.toDataURL("image/png");
    } else if (signatureType === "upload") {
      if (!uploadedImage) {
        alert(t("signature.importImge"));
        return;
      }
      signatureData = uploadedImage;
    }

    try {
      await axios.post(`${BASE_URL}signatures/complete`, {
        token,
        signature: signatureData,
      });
      alert(t("signature.succes"));
    } catch (err) {
      console.error(err);
      alert(t("signature.erreur"));
    }
  };

  const submitRefusal = async () => {
    if (!refusalReason.trim()) {
      alert(t("signature.raisonRefus"));
      return;
    }
    try {
      await axios.post(
        `${BASE_URL}signatures/refuse`,
        {
          token,
          reason: refusalReason,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      alert("Refus envoyé avec succès !");
      setShowRefusalModal(false);
    } catch (err) {
      console.error(err);
      alert(t("signature.erreurRefus"));
    }
  };

  if (loading) return <div>Chargement...</div>;

  return (
    <div className="sign-container">
      <h2>{t("singature.signDoc")}</h2>
      <p>
        {t("signature.destinataire")}: {recipientName.name || recipientName}
      </p>

      {documentUrl && position && (
        <SignableDocument
          fileUrl={getImageURL(documentUrl)}
          signatureData={{ signatureFields: [{ positions: position }] }}
          token={token}
        />
      )}
      {recipientName.signe && (
        <div style={{ marginTop: "20px", marginBottom: "30px" }}>
          <button
            style={{ marginLeft: "10px" }}
            className="btn-refus"
            onClick={() => setShowRefusalModal(true)}>
            {t("signature.refus")}
          </button>
        </div>
      )}

      {showRefusalModal && (
        <Modal
          show={showRefusalModal}
          onHide={() => setShowRefusalModal(false)}
          centered
          className="modal-refus"
          style={{
            borderRadius: "15px !important",
          }}>
          <Modal.Header closeButton>
            <Modal.Title>
              {" "}
              <h3 className="refus-title">{t("signature.rempliRefus")}</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <textarea
              value={refusalReason}
              onChange={(e) => setRefusalReason(e.target.value)}
              rows={5}
              cols={50}
            />
            <div
              style={{ marginTop: "10px" }}
              className="d-flex  justify-content-center gap-3">
              <button
                className="submit-btn"
                type="submit"
                onClick={submitRefusal}>
                {t("signature.envoieRefus")}
                <span className="submit-btn__circle">
                  <FiArrowUp size={24} strokeWidth={1} color={"#F00"} />
                </span>
              </button>
              <button
                className="submit-btn"
                type="submit"
                style={{
                  background: "#0CE0C8",
                }}
                onClick={() => setShowRefusalModal(false)}>
                {t("signature.annuler")}
                <span className="submit-btn__circle">
                  <FiArrowUp size={24} strokeWidth={1} color={"#0CE0C8"} />
                </span>
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}
